import { useMutation, MutationOptions } from "react-query";
import axios, { AxiosResponse, AxiosErrorResponse } from "@/libs/axios";

interface FormSignUpPayload { phone: string; fullname: string }

const signUpAmbassador = (payload: FormSignUpPayload) => {
  return axios.post('/api/v1/user/ambassador/register', payload);
};

export const useSignUpAmbassadorQuery = (
  options?: MutationOptions<AxiosResponse<any>, AxiosErrorResponse, FormSignUpPayload, unknown>
) => {
  return useMutation((payload: FormSignUpPayload) => signUpAmbassador(payload), options);
};